import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Spinner — the one in-progress indicator for every app (ADR-0088 D2).
 *
 * A ring whose top arc turns: Student's brand spinner, kept as the canonical
 * one because it is the version most pages show. Its arc and track use dedicated
 * spinner roles; `surface` selects the track for its host background. The
 * accent arc is yellow: deeper on light neutral surfaces, brand yellow on
 * dark or solid-yellow surfaces.
 * `tone="current"` draws only the arc in the surrounding text color, for a
 * spinner inside a button or colored status line; the surface still owns its
 * track.
 *
 * Decorative by default (`aria-hidden`): the text beside it ("Saving…",
 * "Connecting") already says what is happening. Give it a `label` when it
 * stands alone, and it becomes a `role="status"` region with that name.
 *
 * Reduced motion stops the rotation; the ring stays, with its arc, so the
 * waiting state is still visible.
 */
import { forwardRef } from 'react';
import { cn } from './cn.js';
const surfaces = {
    app: 'border-spinner-track',
    card: 'border-spinner-track-card',
    'accent-soft': 'border-spinner-track-accent-soft',
    accent: 'border-spinner-track-accent',
    'danger-soft': 'border-spinner-track-danger-soft',
};
const tones = {
    accent: 'border-t-spinner-arc',
    current: 'border-t-current',
};
export const Spinner = forwardRef(({ size, thickness, tone = 'accent', surface = 'app', label, className, style, ...props }, ref) => (_jsx("span", { ref: ref, "data-slot": "spinner", ...(label ? { role: 'status', 'aria-label': label } : { 'aria-hidden': true }), className: cn('block size-6 shrink-0 animate-spin rounded-full border-4 border-solid motion-reduce:animate-none', surfaces[surface], surface === 'danger-soft' || tone === 'current'
        ? tones.current
        : surface === 'accent' ? 'border-t-accent' : tones.accent, className), style: { width: size, height: size, borderWidth: thickness, ...style }, ...props })));
Spinner.displayName = 'Spinner';
//# sourceMappingURL=spinner.js.map